module.exports = __webpack_public_path__ + "media/ejw/ejw_48-907ef739.png";